var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagementIconAdv0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7938 46.1616H40.8438V46.1116V9.52471V9.47471H40.7938H4.20693H4.15693V9.52471V46.1116V46.1616H4.20693H40.7938ZM5.38889 5.86812H39.6111C42.2724 5.86812 44.45 8.04573 44.45 10.707V44.9292C44.45 47.5905 42.2724 49.7681 39.6111 49.7681H5.38889C2.72761 49.7681 0.55 47.5905 0.55 44.9292V10.707C0.55 8.04573 2.72761 5.86812 5.38889 5.86812ZM10.3278 22.9792H15.1167V39.9903H10.3278V22.9792ZM20.1056 15.6459H24.8944V39.9903H20.1056V15.6459ZM29.8833 30.3126H34.6722V39.9903H29.8833V30.3126Z",
    fill: "#646AFF",
    stroke: "#F5F5F5",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIconAdv0);
export default __webpack_public_path__ + "static/media/management-icon-adv-0.989d7d1d1eaf5c21e72af53fe8e8a841.svg";
export { ForwardRef as ReactComponent };